import { HighlightCard } from "../components/HighlightCard";
import { useSchoolLocal } from "../useSchoolLocal";
import {
  HomeActivitiesIcon,
  JoinSessionIcon,
  TreatmentPlanIcon,
  WeeklyProgressIcon,
} from "./ProgressIcons";

const PROGRESS_FEATURES = [
  { key: "treatmentPlan", Icon: TreatmentPlanIcon },
  { key: "weeklyProgress", Icon: WeeklyProgressIcon },
  { key: "homeActivities", Icon: HomeActivitiesIcon },
  { key: "joinSession", Icon: JoinSessionIcon },
];

export const ProgressSharing = () => {
  const { t, headingFont } = useSchoolLocal();

  return (
    <div className="mt-10 rounded-2xl bg-[#F8F8F8] px-5 py-6 md:p-9">
      <h3 className={`mb-1.5 text-xl font-bold md:text-2xl ${headingFont}`}>
        {t("whatWeOffer.progress.title")}
      </h3>
      <p className="mb-6 text-[#3D3C56]">{t("whatWeOffer.progress.lead")}</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {PROGRESS_FEATURES.map(({ key, Icon }) => (
          <HighlightCard key={key}>
            <span className="mb-3.5 grid h-11 w-11 place-items-center rounded-xl bg-[#EEEDFD] text-[#4242CE]">
              <Icon />
            </span>
            <h4 className="mb-1.5 text-[16px] font-bold">
              {t(`whatWeOffer.progress.features.${key}.title`)}
            </h4>
            <p className="text-sm leading-relaxed text-[#828282]">
              {t(`whatWeOffer.progress.features.${key}.description`)}
            </p>
          </HighlightCard>
        ))}
      </div>
    </div>
  );
};
